import React from 'react';
import { useFormikContext } from 'formik';
import { ISignersFormData } from './signersForm/buildInitialSignersFormData';
import { css } from '@/styled-system/css';
import { Button } from '@zillow/constellation-10';

export const SignersStepNavigation: React.FC<{ goBack: () => void }> = ({ goBack }) => {
  const { isValid } = useFormikContext<ISignersFormData>();
  return (
    <section className={css({ marginTop: '16', display: 'flex', justifyContent: 'space-between' })}>
      <Button tone={'brand'} emphasis={'outlined'} size="sm" onClick={goBack}>
        Back
      </Button>
      <Button tone={'brand'} emphasis={'filled'} size="sm" type="submit" disabled={!isValid}>
        Next
      </Button>
    </section>
  );
};
